import { ISourceTypeInfo } from "./ISourceTypeInfo";
import { SourceType } from "./SourceType";

export class PreviousStepOutputSourceTypeInfo implements ISourceTypeInfo {
    public readonly sourceType: SourceType = SourceType.previousStepOutput;

    readonly displayName: string = "Previous step output";

    readonly tooltipText: string = "The output of a previous step is used as the input to this transform.";
}